export const SITE_NAME = "ChapterOne Jobs";

/** Set REACT_APP_SITE_URL in production for canonical URLs and sitemap. */
export const SITE_URL =
  process.env.REACT_APP_SITE_URL || "https://chapteronejobs.com";

export function getSiteUrl() {
  if (typeof window !== "undefined" && window.location?.origin) {
    return process.env.REACT_APP_SITE_URL || window.location.origin;
  }
  return SITE_URL;
}
